import React from "react";

// 🏬 Pick-up order marker — shown next to the PO number wherever the order appears.
export function PickupBadge({ order, size = "sm", testid }) {
  if (!order?.is_pickup) return null;
  const cls = size === "lg" ? "text-xs px-2 py-1" : "text-[10px] px-1.5 py-0.5";
  return (
    <span
      data-testid={testid || `pickup-badge-${order.id}`}
      title="Pick-up order — the client collects at the shop (no shipping)"
      className={`inline-flex items-center gap-1 rounded border border-violet-300 bg-violet-50 text-violet-800 font-mono font-semibold uppercase tracking-widest ${cls}`}
    >
      🏬 PICK UP
    </span>
  );
}
